var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"inline-block",attrs:{"to":"/"}},[_c('img',{attrs:{"alt":"Booodata logo","src":require("@/assets/logo-header.svg"),"width":"118","height":"46"}})])}
var staticRenderFns = []

export { render, staticRenderFns }